import React from 'react';

function SplashExplanationIcons({name}) {
  const icons = {
    plan: <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 140 100" enableBackground="new 0 0 140 100">
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M99.6,92.6H40.4c-2.1,0-3.9-1.7-3.9-3.8V11.5
          c0-2.1,1.7-3.8,3.9-3.8h59.3c2.1,0,3.9,1.7,3.9,3.8v77.3C103.5,90.9,101.8,92.6,99.6,92.6z"/>
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M51.5,24.6l12,12"/>
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M63.5,24.6l-12,12"/>
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M90.5,69.1c0,4.1-3.4,7.5-7.5,7.5s-7.5-3.4-7.5-7.5
          c0-4.1,3.4-7.5,7.5-7.5S90.5,65,90.5,69.1z"/>
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M56.5,77.6c0-8.6,2.1-32.6,34-41"/>
        <polyline fill="none" stroke="#0D47A1" strokeWidth="2" points="79.5,31.6 90.5,37.3 84.5,47.6 "/>
      </svg>,
    progress: <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 140 100" enableBackground="new 0 0 140 100">
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M39,50.9l12,12"/>
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M51,50.9l-12,12"/>
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M86,20.9l12,12"/>
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M98,20.9l-12,12"/>
        <polyline fill="none" stroke="#0D47A1" strokeWidth="2" points="100,49.9 88.4,60.9 83,55.8 "/>
        <polyline fill="none" stroke="#0D47A1" strokeWidth="2" points="54,21.9 42.4,32.9 37,27.8 "/>
        <polyline fill="none" stroke="#0D47A1" strokeWidth="2" points="100.1,76.3 88.8,87.5 83.5,82.3 "/>
        <polyline fill="none" stroke="#0D47A1" strokeWidth="2" points="53.9,76.3 42.6,87.5 37.3,82.3 "/>
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M26,7.4H114"/>
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M70,92.9V7.4"/>
      </svg>,
    baseline: <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 140 100" enableBackground="new 0 0 140 100">
        <path fill="none" stroke="#0D47A1" strokeWidth="2" d="M9.5,58.6h121"/>
        <polygon fill="none" stroke="#0D47A1" strokeWidth="2" points="21.8,58.6 35.8,58.6 35.8,35.6 21.8,35.6 "/>
        <polygon fill="none" stroke="#0D47A1" strokeWidth="2" points="44.6,76.6 58.6,76.6 58.6,58.6 44.6,58.6 "/>
        <polygon fill="none" stroke="#0D47A1" strokeWidth="2" points="78.8,58.6 92.8,58.6 92.8,23.6 78.8,23.6 "/>
        <polygon fill="none" stroke="#0D47A1" strokeWidth="2" points="101.6,58.6 115.6,58.6 115.6,35.6 101.6,35.6 "/>
      </svg>
  }

  return icons[name];
}

export default SplashExplanationIcons;



// WEBPACK FOOTER //
// ./src/components/features/splash/SplashExplanationIcons.js